import {
  DateTimeFormatter,
  Duration,
  LocalDate,
  ZonedDateTime,
} from '@js-joda/core';

const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const checkYearNotInFuture = (year: string): boolean => {
  const currentYear = new Date().getFullYear();
  return Number(year) <= currentYear;
};

interface ToRelativeFromISOOptions {
  // Max number of days to display (e.g., 2d+)
  maxDays?: number;
}

/**
 * Returns a relative time string in narrow style (e.g., 2m, 1h, 2d).
 */
export function toRelativeFromISO(
  isoDate: string,
  options: ToRelativeFromISOOptions,
): string {
  return toRelative_InternalUseOnly(
    ZonedDateTime.parse(isoDate),
    ZonedDateTime.now(),
    options,
  );
}

export function toRelative_InternalUseOnly(
  date: ZonedDateTime,
  referenceDate: ZonedDateTime,
  { maxDays }: ToRelativeFromISOOptions = {},
): string {
  const delta = Duration.between(date, referenceDate);
  const minutes = delta.toMinutes();

  if (minutes < MINUTES_IN_HOUR) {
    return `${minutes}m`;
  }

  const hours = delta.toHours();

  if (hours < HOURS_IN_DAY) {
    return `${hours}h`;
  }

  const days = delta.toDays();

  if (maxDays && days > maxDays) {
    return `${maxDays}d+`;
  }

  return `${days}d`;
}

export function toMonthDayAndTime(isoDate: string): [string, string] {
  const date = ZonedDateTime.parse(isoDate);
  const datePattern = DateTimeFormatter.ofPattern('MMM dd');
  const timePattern = DateTimeFormatter.ofPattern('HH:mm ZZZZ');

  return [date.format(datePattern), date.format(timePattern)];
}

export const getLocalDate = (date: Date) =>
  LocalDate.of(date.getFullYear(), date.getMonth() + 1, date.getDate());

// get MM/dd/yyyy from date object with 0 padding month and day
export const getFormattedDate = (date: Date) => {
  const month = date.getMonth() + 1;
  const day = date.getDate() + 1;
  const year = date.getFullYear();

  const monthStr = month < 10 ? `0${month}` : `${month}`;
  const dayStr = day < 10 ? `0${day}` : `${day}`;

  return `${monthStr}/${dayStr}/${year}`;
};
